import { ComponentSingleStyleConfig } from '@chakra-ui/theme/dist/types/theme.types';

export const Box: ComponentSingleStyleConfig = {
  variants: {
    'chakraSelect.Box': {
      position: 'relative',
      flex: 1
    },
  },
};
